// extracted by mini-css-extract-plugin
module.exports = {"footerItems":"page-footer_footerItems__3z95F","footerContainer":"page-footer_footerContainer__ZZ6FQ","footerSelector":"page-footer_footerSelector__1mQdh"};